import { render } from "./Test5.vue?vue&type=template&id=50194ee8&ts=true"
import script from "./Test5.vue?vue&type=script&lang=ts"
export * from "./Test5.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__